import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    highlighted: [],
    columns: {},
    data: {},
    loadingStatus: 'idle',
    error: null
}

export const fetchDetails = createAsyncThunk(
    'details/fetchDetails',
    async({departureId, token}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `${APP_URL}/reports/${departureId}`,
                'GET',
                null,
                customHeaders
            );

            return response
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
);

const detailsSlice = createSlice({
    name: 'details',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDetails.pending, (state) => {
                state.loadingStatus = 'loading';
                state.number = null;
                state.columns = null;
                state.data = null;
                state.error = null;
            })
            .addCase(fetchDetails.fulfilled, (state, action) => {
                state.loadingStatus = 'idle';
                state.highlighted = action.payload.highlighted;
                state.columns = action.payload.columns;
                state.data = action.payload.data;
                state.error = null;
            })
            .addCase(fetchDetails.rejected, (state, action) => {
                state.loadingStatus = 'error';
                state.number = null;
                state.columns = null;
                state.data = null;
                state.error = null;
            })
    }
});

export default detailsSlice.reducer;